import { TprecmAuthorizationService } from './../../authorization/tprecm-authorization.service';
import { ToastrService } from 'ngx-toastr';
import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { ChangeLogAddModalComponent } from './change-log-add-modal/change-log-add-modal.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataTableService } from './../../../../shared/data-table/data-table.service';
import { PageOptions, ColumnDef } from './../../../../shared/data-table/data-table.interface';
import { ChangeLogModalService } from './change-log-modal.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'change-log-modal',
  templateUrl: './change-log-modal.component.html',
})
export class ChangeLogModalComponent implements OnInit {

  loading = true;

  changelogs: any[];

  page: PageOptions = this.dataTableService.pageOptionsDefaultSort('id', 'desc');
  total = 0;

  columns: ColumnDef[] = [
    { field: 'title', name: 'Title', editable: false },
    { field: 'description', name: 'Description', editable: false },
    { field: 'changeDate', type: 'date', name: 'Change Date', editable: false },
    { field: 'revision', name: 'Revision', editable: false, width: '3em' }
  ];

  @ViewChild('dataTable', { static: true }) dataTable: DataTableComponent;

  constructor(
    private readonly changelogService: ChangeLogModalService,
    private readonly dataTableService: DataTableService,
    private readonly dialog: MatDialog,
    private readonly confirmation: CgpConfirmationDialogService,
    private readonly toastr: ToastrService,
    private readonly authorization: TprecmAuthorizationService
  ) { }

  ngOnInit(): void {
    this.loadChangeLogs();
  }

  loadChangeLogs() {
    this.loading = true;
    this.dataTable.selected = null;

    this.changelogService.getChangeLogs(this.page)
      .subscribe((response) => {
        this.changelogs = response.data;
        this.total = response.totalCount;

        this.loading = false;
      });
  }

  onLazyLoad(event: LazyLoadEvent) {
    this.page.order = event.sortOrder === 1 ? 'asc' : 'desc';
    this.page.size = event.rows;
    this.page.sort = event.sortField;
    this.page.page = event.first / this.page.size;

    this.loadChangeLogs();
  }

  addChangeLog() {
    this.dialog.open(ChangeLogAddModalComponent, { width: '20vw', height: '50vh' })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => this.loadChangeLogs());
  }

  editChangeLog() {
    if (!this.dataTable.selected) {
      this.toastr.error('Please select a change log row to edit.');
      return;
    }

    this.dialog.open(ChangeLogAddModalComponent, {
      width: '20vw',
      height: '50vh',
      data: this.dataTable.selected
    }).afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => this.loadChangeLogs());
  }

  deleteChangeLog() {
    const id = (this.dataTable.selected || {}).id;

    if (id) {
      this.confirmation.showConfirmationDialog({
        message: 'Do you want to delete this change log?',
        onYesClick: () => {
          this.changelogService.deleteChangeLog(id)
            .subscribe(() => this.loadChangeLogs());
          this.confirmation.closeConfirmationDialog();
          this.dataTable.selected = undefined;
        },
        onNoClick: () => this.confirmation.closeConfirmationDialog()
      });
    } else {
      this.toastr.error('Please select a change log to delete.');
    }
  }

  isSuperUser() {
    return this.authorization.userRoleId()
      .pipe(map(id => id === 1));
  }
}
